export default __webpack_public_path__ + "static/media/uploader-roche-4.7182c085.png";